import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Home from './pages/Home';
import Products from './pages/Products';
import Error404 from './pages/Error404';
import Productdetails from './pages/Productdetails';
import AboutPage from './pages/About';
import Useraccountsettings from './pages/Useraccountsettings';
import Userorderpage from './pages/Userorderpage';
import Checkout from './pages/Checkout';
import Cart from './pages/Cart';
import Contact from './pages/Contact';
import Userprofile from './pages/Userprofile';
import Orderhistory from './pages/Orderhistory';
import GoogleLogin from './pages/Login';
import { SignedIn, SignedOut } from '@clerk/clerk-react';
import CheckoutForm from './components/checkoutComponents/CheckoutForm';
import Return from './components/checkoutComponents/Return';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<GoogleLogin />} />
        <Route path="/products" element={<Products/>}/>
        <Route path="/products/:productType/:productName" element={<Productdetails />} />
        <Route path="/aboutpage" element={<AboutPage/>}/>
        <Route path="/contact" element={<Contact/>}/>
        <Route path="/shop" element={<Products/>}/>

        <Route path="*" element={<Error404 />} />

        {/* Protected Routes - Only accessible when signed in */}
        <Route
          path="/cart"
          element={
            <>
              <SignedIn>
                <Cart />
              </SignedIn>
              <SignedOut>
                <Navigate to="/login" replace />
              </SignedOut>
            </>
          }
        />
        <Route
          path="/checkout"
          element={
            <>
              <SignedIn>
                <Checkout />
              </SignedIn>
              <SignedOut>
                <Navigate to="/login" replace />
              </SignedOut>
            </>
          }
        />
        <Route
          path="/checkoutform"
          element={
            <>
              <SignedIn>
                <CheckoutForm />
              </SignedIn>
              <SignedOut>
                <Navigate to="/login" replace />
              </SignedOut>
            </>
          }
        />
        <Route
          path="/return"
          element={
            <>
              <SignedIn>
                <Return />
              </SignedIn>
              <SignedOut>
                <Navigate to="/login" replace />
              </SignedOut>
            </>
          }
        />
        <Route
          path="/useraccountsettings"
          element={
            <>
              <SignedIn>
                <Useraccountsettings />
              </SignedIn>
              <SignedOut>
                <Navigate to="/login" replace />
              </SignedOut>
            </>
          }
        />
        <Route
          path="/userorderdetail/:id"
          element={
            <>
              <SignedIn>
                <Userorderpage />
              </SignedIn>
              <SignedOut>
                <Navigate to="/login" replace />
              </SignedOut>
            </>
          }
        />
        <Route
          path="/profile"
          element={
            <>
              <SignedIn>
                <Userprofile />
              </SignedIn>
              <SignedOut>
                <Navigate to="/login" replace />
              </SignedOut>
            </>
          }
        />
        <Route
          path="/order-history"
          element={
            <>
              <SignedIn>
                <Orderhistory />
              </SignedIn>
              <SignedOut>
                <Navigate to="/login" replace />
              </SignedOut>
            </>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;